import { removeNull } from '../../../utils';
import queryString from 'query-string';
import SuperFetchV2 from '../../../superFetchV2';
import {
  AccountSellersQueryParamType,
  AccountSellersResponseType,
} from '../../../../views/account/seller/common/types/AccountSellersType';

export const AccountSellerApiV2 = {
  /**
   *  판매자 리스트 요청하기
   */
  fetchSellers: (params: AccountSellersQueryParamType): Promise<AccountSellersResponseType> => {
    const filteredParams = removeNull(params);
    const queryParams = queryString.stringify({ ...filteredParams }, { skipEmptyString: true });
    return SuperFetchV2.get(`/sellers?${queryParams}`);
  },
};
